import { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";
import Dialog from "components/DialogV2";
import DialogHeader from "components/DialogV2/DialogHeader";
import DialogTitle from "components/DialogV2/DialogTitle";
import DialogClose from "components/DialogV2/DialogClose";
import DialogContent from "components/DialogV2/DialogContent";
import DialogActions from "components/DialogV2/DialogActions";
import Button from "components/Button";
import Typography from "components/Typography";
import Div from "components/primitives/Div";
import { Athlete } from "types/athlete";
import AthleteHelpers from "helpers/AthleteHelpers";

interface ArchiveAthleteDialogProps {
  open: boolean;
  athlete: Athlete;
  onCancel: () => void;
  onConfirm: () => void;
}

function ArchiveAthleteDialog(props: ArchiveAthleteDialogProps) {
  const { athlete, onConfirm, onCancel, open } = props;
  const { t } = useTranslation();

  const athleteName = useMemo(() => AthleteHelpers.getFullName(athlete), [athlete]);

  return (
    <Dialog open={open} onClose={onCancel} width={350}>
      <DialogHeader>
        <DialogTitle>{t("edit_athlete.archive_button_text")}</DialogTitle>
        <DialogClose />
      </DialogHeader>
      <DialogContent sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
        <Div sx={{ display: "flex", alignItems: "center", gap: 1.5, flexDirection: "column", mb: 2 }}>
          <Typography textAlign="center" fontWeight="fontWeightMedium" data-sensitive>
            {t("edit_athlete.archive_confirmation_message", { name: athleteName })}
          </Typography>
        </Div>
      </DialogContent>
      <DialogActions sx={{ flexDirection: "column", gap: 2, pt: 2 }}>
        <Button onClick={onConfirm} variant="danger" size="small" fullWidth>
          {t("edit_athlete.archive_button_text")}
        </Button>
        <Button variant="tertiary" size="small" fullWidth onClick={onCancel}>
          {t("global.cancel_button_text")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default memo(ArchiveAthleteDialog);
